/**
 * Pure helpers shared by both bootstrap populators (`Bootstrap` and
 * `BootstrapFromVolt`) to do the wire-data → app-data work that's
 * identical across branches. Each helper takes plain primitives so it
 * is branch-agnostic at the call site.
 */

/**
 * Picks the active cloudId for this request. Prefers the caller's URL-derived
 * hint (Relay's `queryRef.variables.context.cloudId` for GQL, a URL parse for
 * Volt); falls back to the first entry in `cloudIds`; finally `null`.
 *
 * TODO: once the server inlines the resolved `activeCloudId` into the bootstrap
 * payload, both branches can drop the URL-hint argument.
 */
export function deriveContextCloudId(
	urlCloudIdHint: string | undefined,
	cloudIds: readonly string[],
): string | null {
	return urlCloudIdHint ?? cloudIds[0] ?? null;
}

/** Volt-side URL parse for the cloudId hint. */
export function readCloudIdFromUrl(): string | undefined {
	return window.location.pathname.match(/\/(?:s|cloud)\/([^/]+)/)?.[1];
}
